/* models/formatters/printf_tick_formatter.js */ function _(require, module, exports) {
    const tick_formatter_1 = require(107) /* ./tick_formatter */;
    const templating_1 = require(151) /* ../../core/util/templating */;
    const p = require(18) /* ../../core/properties */;
    class PrintfTickFormatter extends tick_formatter_1.TickFormatter {
        constructor(attrs) {
            super(attrs);
        }
        static init_PrintfTickFormatter() {
            this.define({
                format: [p.String, '%s'],
            });
        }
        doFormat(ticks, _opts) {
            return ticks.map((tick) => templating_1.sprintf(this.format, tick));
        }
    }
    exports.PrintfTickFormatter = PrintfTickFormatter;
    PrintfTickFormatter.__name__ = "PrintfTickFormatter";
    PrintfTickFormatter.init_PrintfTickFormatter();
}
